import { all, call, put, takeEvery } from 'redux-saga/effects'
import FleetManagementApiService from './FleetManagementApiService'
import { GET_FLEET_ITEM_DETAILS, GET_FLEET_ITEM_HEADER_DETAILS, GET_FLEET_ITEM_PURCHASE_DETAILS, GET_FLEET_ITEM_PURCHASE_DETAILS_SAVE, GET_FLEET_ITEM_PURCHASE_ORDER, GET_FLEET_ITEM_PURCHASE_ORDER_SAVE, GET_FLEET_ITEM_TASK_DETAILS, GET_FLEET_ITEM_VENDOR_DETAILS, GET_FLEET_ITEM_VENDOR_DETAILS_SAVE, GET_ORDER_HEADER_DETAILS, SAVE_COMMENT, SAVE_ITEM_ATTACHMENTS_LINKED, SAVE_ITEM_DETAILS, SAVE_MULTIPLE_DEALER_VENDOR_DETAILS, SAVE_MULTIPLE_PO_DETAILS, SAVE_MULTIPLE_PURCHASE_DETAILS, SAVE_CONSOLIDATED_PO_FLAG, SAVE_ASSIGNED_TO_FOR_ALL_ITEM, VALIDATE_VIN_DUPLICATE, SAVE_CATALOG_OVERRIDE } from 'Store/Component/FleetManagement/FleetManagementType'
import { setFleetItemDetails, setFleetItemHeaderDetail, setFleetItemPurchaseDetails, setFleetItemPurchaseDetailsSave, setFleetItemPurchaseOrder, setFleetItemPurchaseOrderSave, setFleetItemTaskDetails, setFleetItemVendorDetails, setFleetItemVendorDetailsSave, setOrderHeaderDetail, setCommentSaved, setIsItemSaved, setIsMultipleDealerVendorSaved, setIsMultiplePurchaseOrderSaved, setIsConsolidatedPOFlagSaved, setAssignedToForAllItem, setVinValidationResult, setCatalogOverrideSaved } from 'Store/Component/FleetManagement/FleetManagementAction'
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { setValidateAndSavePOSuccess } from 'Store/OrderManagement/FleetProcessing/FleetProcessingAction';
import { globalLoaderText } from 'redux/CommonDashboard/actions';

function* getFleetOrderHeaderDetails(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Order Details...."));
        let payloadData : IPayload= {
            apiType : apiType.FleetManagement,
            endpoint : `requisition/fleet/orderheader/${req.orderId}`,
            apiMethod :  apiMethod.GET,
            payload : null
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData            
        );
        if (response) {
            yield put(setOrderHeaderDetail(response))
            yield put(globalLoaderText(""));
        } else {
            yield put(setOrderHeaderDetail({}))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setOrderHeaderDetail({}))
        yield put(globalLoaderText(""));
    }
}

function* getFleetItemHeaderDetails(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Fleet Items...."));
        let payloadData : IPayload= {
            apiType : apiType.FleetManagement,
            endpoint : `requisition/fleet/fleetheader/${req.orderId}`,
            apiMethod :  apiMethod.GET,
            payload : null
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData            
        );
        if (response) {
            yield put(setFleetItemHeaderDetail(response));
            yield put(globalLoaderText(""));
        } else {
            yield put(setFleetItemHeaderDetail([]))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setFleetItemHeaderDetail([]))
        yield put(globalLoaderText(""));
    }
}

function* getFleetItemDetails(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Fleet Item Details...."));
        let payloadData : IPayload= {
            apiType : apiType.FleetManagement,
            endpoint : `requisition/fleet/item/details/${req.fleetId}`,
            apiMethod :  apiMethod.GET,
            payload : null
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData            
        );
        if (response) {
            yield put(setFleetItemDetails({...response, fleetId: req.fleetId}))
            yield put(globalLoaderText(""));
        } else {
            yield put(setFleetItemDetails({}))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setFleetItemDetails({}))
        yield put(globalLoaderText(""));
    }
}

function* getFleetItemPurchaseDetails(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Purchase Details...."));
        let payloadData : IPayload= {
            apiType : apiType.FleetManagement,
            endpoint : `requisition/fleet/purchasedetail/${req.fleetId}`,
            apiMethod :  apiMethod.GET,
            payload : null
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData            
        );
        if (response) {
            yield put(setFleetItemPurchaseDetails({...response, fleetId: req.fleetId, isPurchaseDetailsSave : true}))
            yield put(globalLoaderText(""));
        } else {
            yield put(setFleetItemPurchaseDetails({}))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setFleetItemPurchaseDetails({}))
        yield put(globalLoaderText(""));
    }
}

function* getFleetItemPurchaseOrder(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Purchase Order Details...."));
        let payloadData : IPayload= {
            apiType : apiType.FleetManagement,
            endpoint : `requisition/fleet/purchaseorder/${req.fleetId}`,
            apiMethod :  apiMethod.GET,
            payload : null
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData            
        );
        if (response) {
            yield put(setFleetItemPurchaseOrder({...response, fleetId: req.fleetId, isPurchaseOrderSave: true}))
            yield put(globalLoaderText(""));
        } else {
            yield put(setFleetItemPurchaseOrder({}))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setFleetItemPurchaseOrder({}))
        yield put(globalLoaderText(""));
    }
}

function* getFleetItemVendorDetails(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Dealer Details...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `requisition/fleet/dealerdetails/${req.fleetId}`,
            apiMethod: apiMethod.GET,
            payload: null
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setFleetItemVendorDetails({ ...response, fleetId: req.fleetId, isDealerVendorSave : true }))
            yield put(globalLoaderText(""));
        } else {
            yield put(setFleetItemVendorDetails({}))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setFleetItemVendorDetails({}))
        yield put(globalLoaderText(""));
    }
}

function* getFleetItemTaskDetails(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Task Details...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `requisition/fleet/item/task/${req.fleetId}`,
            apiMethod: apiMethod.GET,
            payload: null
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setFleetItemTaskDetails({ poFleetRequestTaskListTrackings: response, fleetId: req.fleetId }))
            yield put(globalLoaderText(""));
        } else {
            yield put(setFleetItemTaskDetails({}))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setFleetItemTaskDetails({}))
        yield put(globalLoaderText(""));
    }
}

function* getFleetItemPurchaseDetailsSave(req: any): any {
    try {
        yield put(globalLoaderText("Saving Purchase Details...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `fleet/item/purchasedetail`,
            apiMethod: apiMethod.POST,
            payload: req.purchaseDetails
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData
        );
        yield put(setFleetItemPurchaseDetailsSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setFleetItemPurchaseDetailsSave({fleetDetailId: req.purchaseDetails?.fleetRequestDetailId,  success: false,  pricePerUnit: 0}))
        yield put(globalLoaderText(""));
    }
}

function* getFleetItemPurchaseOrderSave(req: any): any {
    try {
        yield put(globalLoaderText("Saving Purchase Order Details...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `requisition/fleet/purchaseorder`,
            apiMethod: apiMethod.POST,
            payload: req.purchaseOrderdetails
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData
        );
        yield put(setFleetItemPurchaseOrderSave(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setFleetItemPurchaseOrderSave({ fleetDetailId: req.purchaseOrderdetails?.fleetDetailId, isSaved: false }))
        yield put(globalLoaderText(""));
    }
}

function* saveComment(req: any): any {
    try {
        yield put(globalLoaderText("Saving Comment...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `requisition/fleet/item/comments`,
            apiMethod: apiMethod.POST,
            payload: req.comment
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData
        );
        yield put(setCommentSaved({isCommentSaved : response, fleetId: req.comment?.fleetDetailId}))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCommentSaved({isCommentSaved : false, fleetId: req.comment?.fleetDetailId}))
        yield put(globalLoaderText(""));
    }
}

function* getFleetItemVendorDetailsSave(req: any): any {
    try {
        yield put(globalLoaderText("Saving Dealer Details...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `requisition/fleet/dealer`,
            apiMethod: apiMethod.POST,
            payload: req.vendorDetails
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData
        );
        yield put(setFleetItemVendorDetailsSave({isDealerVendorSave : response, fleetId: req.vendorDetails?.fleetRequestDetailId}))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setFleetItemVendorDetailsSave({isDealerVendorSave : false, fleetId: req.vendorDetails?.fleetRequestDetailId}))
        yield put(globalLoaderText(""));
    }
}

function* saveItemDetail(req: any): any {
    try {
        yield put(globalLoaderText("Saving Item Details...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `requisition/fleet/item`,
            apiMethod: apiMethod.POST,
            payload: req.itemDetails
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData
        );
        yield put(setIsItemSaved({ isItemSaved: response, fleetId: req.itemDetails?.fleetRequestDetailId}))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setIsItemSaved({isItemSaved : false, fleetId: req.itemDetails?.fleetRequestDetailId}))
        yield put(globalLoaderText(""));
    }
}

function* saveItemAttachments(req: any): any {
    try {
        yield put(globalLoaderText("Saving Attachments...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `requisition/fleet/update/attachments`,
            apiMethod: apiMethod.POST,
            payload: req.attachmentsDetails
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData
        );
        yield put(setIsItemSaved({ isItemAttachmentsSaved: response, fleetId: req.attachmentsDetails?.fleetRequestDetailId}))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setIsItemSaved({isItemAttachmentsSaved : false, fleetId: req.attachmentsDetails?.fleetRequestDetailId}))
        yield put(globalLoaderText(""));
    }
}

function* saveMultiPOD(req: any): any {
    try {
        yield put(globalLoaderText("Saving Purchase Details...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `fleet/items/purchasedetail/validateandsave`,
            apiMethod: apiMethod.POST,
            payload: req.purchaseDetails
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData
        );
        yield put(setValidateAndSavePOSuccess(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setValidateAndSavePOSuccess(false))
        yield put(globalLoaderText(""));
    }
}

function* saveMultiDealers(req: any): any {
    try {
        yield put(globalLoaderText("Saving Dealer Details...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `requisition/fleet/items/dealerdetails`,
            apiMethod: apiMethod.POST,
            payload: req.dealerdetails
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData
        );
        yield put(setIsMultipleDealerVendorSaved(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setIsMultipleDealerVendorSaved(false))
        yield put(globalLoaderText(""));
    }
}

function* saveMultiPurchaseOrder(req: any): any {
    try {
        yield put(globalLoaderText("Saving Purchase Order Details...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `requisition/fleet/items/purchaseorders`,
            apiMethod: apiMethod.POST,
            payload: req.purchaseOrderdetails
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData
        );
        yield put(setIsMultiplePurchaseOrderSaved(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setIsMultiplePurchaseOrderSaved({ isSaved: false }))
        yield put(globalLoaderText(""));
    }
}

function* saveConsolidatedPOFlag(req: any): any {
    try {
        yield put(globalLoaderText("Saving Consolidated PO Flag...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `requisition/fleet/items/consolidatedpo`,
            apiMethod: apiMethod.POST,
            payload: req.payload
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData
        );
        yield put(setIsConsolidatedPOFlagSaved(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setIsConsolidatedPOFlagSaved(false))
        yield put(globalLoaderText(""));
    }
}

function* saveAssignedToForAllItem(req: any): any {
    try {
        yield put(globalLoaderText("Saving Assigned to for all item...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `requisition/fleet/purchaseOrder/assignedTo`,
            apiMethod: apiMethod.POST,
            payload: req.payload
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData
        );
        yield put(setAssignedToForAllItem({
            response,
            payload: req.payload
        }))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* validateVinDuplicate(req: any): any {
    try {
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: 'fleet/validate/vin',
            apiMethod: apiMethod.POST,
            payload: {
                vinSerial: req.vinSerial,
                currentOrderRequestDetailId: req.currentOrderRequestDetailId,
                currentFleetRequestDetailId: req.currentFleetRequestDetailId
            }
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData
        );
        
        if (response) {
            yield put(setVinValidationResult(response));
        } else {
            yield put(setVinValidationResult(null));
        }
    } catch (error) {
        console.error('Error validating VIN:', error);
        yield put(setVinValidationResult(null));
    }
}

function* saveCatalogOverride(req: any): any {
    try {
        yield put(globalLoaderText("Saving Catalog Override...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `fleet/catalogoverride`,
            apiMethod: apiMethod.POST,
            payload: req.catalogOverrideDetails
        }

        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData
        );
        yield put(setCatalogOverrideSaved({ ...response, fleetRequestDetailId: req.catalogOverrideDetails?.fleetRequestDetailId }));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogOverrideSaved({ success: false, fleetRequestDetailId: req.catalogOverrideDetails?.fleetRequestDetailId }));
        yield put(globalLoaderText(""));
    }
}

function* watchFleetManagement() {
    yield takeEvery(GET_ORDER_HEADER_DETAILS, getFleetOrderHeaderDetails)
    yield takeEvery(GET_FLEET_ITEM_HEADER_DETAILS, getFleetItemHeaderDetails)
    yield takeEvery(GET_FLEET_ITEM_DETAILS, getFleetItemDetails)
    yield takeEvery(GET_FLEET_ITEM_PURCHASE_DETAILS, getFleetItemPurchaseDetails)
    yield takeEvery(GET_FLEET_ITEM_PURCHASE_ORDER, getFleetItemPurchaseOrder)
    yield takeEvery(GET_FLEET_ITEM_VENDOR_DETAILS, getFleetItemVendorDetails)
    yield takeEvery(GET_FLEET_ITEM_TASK_DETAILS, getFleetItemTaskDetails)
    yield takeEvery(GET_FLEET_ITEM_PURCHASE_DETAILS_SAVE, getFleetItemPurchaseDetailsSave)
    yield takeEvery(GET_FLEET_ITEM_PURCHASE_ORDER_SAVE, getFleetItemPurchaseOrderSave)
    yield takeEvery(GET_FLEET_ITEM_VENDOR_DETAILS_SAVE, getFleetItemVendorDetailsSave)
    yield takeEvery(SAVE_COMMENT, saveComment)
    yield takeEvery(SAVE_ITEM_DETAILS, saveItemDetail)
    yield takeEvery(SAVE_ITEM_ATTACHMENTS_LINKED, saveItemAttachments)
    yield takeEvery(SAVE_MULTIPLE_PURCHASE_DETAILS, saveMultiPOD)
    yield takeEvery(SAVE_MULTIPLE_DEALER_VENDOR_DETAILS, saveMultiDealers)
    yield takeEvery(SAVE_MULTIPLE_PO_DETAILS, saveMultiPurchaseOrder)
    yield takeEvery(SAVE_CONSOLIDATED_PO_FLAG, saveConsolidatedPOFlag)
    yield takeEvery(SAVE_ASSIGNED_TO_FOR_ALL_ITEM, saveAssignedToForAllItem)
    yield takeEvery(VALIDATE_VIN_DUPLICATE, validateVinDuplicate)
    yield takeEvery(SAVE_CATALOG_OVERRIDE, saveCatalogOverride)
}

export default function* combinedSaga() {
    yield all([
        watchFleetManagement()
    ])
}
